import { createComponent } from '@/helpers/alpine';

enum ECheckoutStepIdentifier {
    INFORMATION = 'checkout-personal-information-step',
    ADRESSES = 'checkout-addresses-step',
    DELIVERY = 'checkout-delivery-step',
    CHECKOUT = 'checkout-payment-step',
}

enum ECheckoutStepIdentifierIcon {
    INFORMATION = 'i-account',
    ADRESSES = 'i-checklist',
    DELIVERY = 'i-truck',
    CHECKOUT = 'i-card',
}

type TCheckoutStepOpts = {
    identifier: ECheckoutStepIdentifier;
    isCurrent: boolean;
    isReachable: boolean;
};

const CheckoutStep = createComponent((opts: TCheckoutStepOpts) => ({
    identifier: opts.identifier,
    isCurrent: opts.isCurrent,
    isReachable: opts.isReachable,

    get id() {
        const idx = Object.values(ECheckoutStepIdentifier).indexOf(
            this.identifier,
        );

        return Object.keys(ECheckoutStepIdentifier)[
            idx
        ] as keyof typeof ECheckoutStepIdentifierIcon;
    },

    get isUnreachable() {
        return !this.isCurrent && !this.isReachable;
    },

    get isValidated() {
        return !this.isCurrent && this.isReachable;
    },

    get icon() {
        return ECheckoutStepIdentifierIcon[this.id];
    },

    goTo() {
        if (this.isCurrent || this.isUnreachable) {
            return;
        }

        this.$dispatch('checkout:update-step', this.identifier);
    },

    init() {
        if (this.isCurrent) {
            this.$dispatch('checkout:update-step', this.identifier);
        }
        window.addEventListener('checkout:updated-step', (event) => {
            this.isCurrent = (event as CustomEvent).detail == this.identifier;
        });
    },
}));

export { CheckoutStep };
